module.exports = __webpack_public_path__ + "_assets/img/x.ee636d80.svg";